.audio-player {
    height: 37px;
    align-content: center;
}
